import classes from "./IconLabel.module.css";
const IconLabel = (props) => {
  return <i className={`${classes["icon-label"]} ${props.className}`} />;
};

export default IconLabel;
